<template>
  <div class="min-h-screen bg-gray-50 pb-24">
    <!-- 顶部提示 -->
    <div class="notice-tip">
      客户是否满意（不满意请反馈派单老师）
    </div>

    <!-- 分组折叠表单 -->
    <div class="px-3">
      <!-- 基本信息 -->
      <div class="card">
        <div class="card-header" @click="toggleSection('basic')">
          <span class="card-title"><span class="bar"></span>基本信息 <span class="required-count" v-if="basicRequiredMissing">有未填必填项</span></span>
          <i class="fa" :class="sections.basic ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.basic">
          <div class="field-row">
            <label class="field-label-inline">陪诊渠道</label>
            <select v-model="ticket.channel" class="field-input-inline">
              <option value="default">默认渠道</option>
              <option value="fushoukang">福寿康</option>
            </select>
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>陪诊姓名（可修改）</label>
            <input v-model="ticket.escort_name" value="" class="field-input-inline" placeholder="请输入陪诊姓名" />
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>客户姓名</label>
            <input v-model="ticket.customer_name" class="field-input-inline" placeholder="请输入客户姓名" />
          </div>
          <!-- 就诊医院：输入搜索 -->
          <div class="field-row hospital-search-row">
            <label class="field-label-inline"><span class="req">*</span>就诊医院</label>
            <div class="hospital-search-box">
              <input
                v-model="hospitalKeyword"
                class="field-input-inline"
                placeholder="输入医院/省市关键词搜索"
                @focus="hospitalDropdownShow = true"
                @input="onHospitalInput"
                @blur="onHospitalBlur"
              />
              <i v-if="hospitalKeyword" class="fa fa-times-circle clear-icon" @click="clearHospital"></i>
              <!-- 下拉建议 -->
              <div class="hospital-dropdown" v-if="hospitalDropdownShow && filteredHospitals.length > 0">
                <div
                  v-for="item in filteredHospitals"
                  :key="item.id"
                  class="hospital-option"
                  @mousedown.prevent="selectHospital(item)"
                >
                  <div class="hospital-name">{{ item.hospital_text }}</div>
                  <div class="hospital-area">{{ item.province }} {{ item.city }}</div>
                </div>
              </div>
              <div class="hospital-dropdown" v-else-if="hospitalDropdownShow && hospitalKeyword && filteredHospitals.length === 0">
                <div class="hospital-empty">未找到匹配医院，可直接输入</div>
              </div>
            </div>
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>就诊科室</label>
            <input v-model="ticket.visit_deparment" class="field-input-inline" placeholder="请输入就诊科室" />
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>专家名称</label>
            <input v-model="ticket.visit_doctor" class="field-input-inline" placeholder="请输入专家名称" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">级别</label>
            <input v-model="ticket.level" class="field-input-inline" placeholder="请输入级别" />
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>挂号费</label>
            <input v-model="ticket.register_fee" type="text" class="field-input-inline" placeholder="已收xx已垫xx，无需写0" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">患者病情</label>
            <input v-model="ticket.patient_disease" class="field-input-inline" placeholder="请输入患者基本病情" />
          </div>
          <div class="field-row">
            <label class="field-label-inline"><span class="req">*</span>专家诊断</label>
            <input v-model="ticket.expert_diagnosis" class="field-input-inline" placeholder="请输入专家诊断" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">药品名称</label>
            <input v-model="ticket.medical_name" class="field-input-inline" placeholder="请输入药品名称" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">取药时间</label>
            <input :value="ticket.take_medical_time" readonly @click="openTimePicker('take_medical_time')" class="field-input-inline" placeholder="请选择取药时间段" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">专家建议</label>
            <input v-model="ticket.expert_suggest" class="field-input-inline" placeholder="请输入专家建议" />
          </div>
        </div>
      </div>

      <!-- 时间记录 -->
      <div class="card">
        <div class="card-header" @click="toggleSection('time')">
          <span class="card-title"><span class="bar"></span>时间记录</span>
          <i class="fa" :class="sections.time ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.time">
          <div class="field-row" v-for="field in timeFieldList" :key="field">
            <label class="field-label-inline" v-html="formatLabelWithReq(field)"></label>
            <input :value="ticket[field]" readonly @click="openTimePicker(field)" class="field-input-inline" :placeholder="'请选择' + getFieldLabel(field)" />
          </div>
        </div>
      </div>

      <!-- 检查与住院 -->
      <div class="card">
        <div class="card-header" @click="toggleSection('check')">
          <span class="card-title"><span class="bar"></span>检查与住院</span>
          <i class="fa" :class="sections.check ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.check">
          <div class="field-row">
            <label class="field-label-inline">检查项目</label>
            <input v-model="ticket.check_project" class="field-input-inline" placeholder="请输入检查项目" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">检查时间段</label>
            <input v-model="ticket.check_time_slot" class="field-input-inline" placeholder="请输入办理检查时间段" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">是否开住院证</label>
            <input v-model="ticket.is_hospital_cert" class="field-input-inline" placeholder="请输入是否开住院证" />
          </div>
          <div class="field-row">
            <label class="field-label-inline">是否协调住院</label>
            <input v-model="ticket.is_hospital" class="field-input-inline" placeholder="请输入是否需要协调住院" />
          </div>
        </div>
      </div>

      <!-- 评价 -->
      <div class="card" ref="evalCardRef">
        <div class="card-header" @click="toggleSection('eval')">
          <span class="card-title"><span class="bar"></span>评价(支持数字5分制/文字描述) <span class="required-count" v-if="evalRequiredMissing">有未填必填项</span></span>
          <i class="fa" :class="sections.eval ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.eval">
          <div class="field-row eval-row" v-for="field in evalFields" :key="field.scoreKey">
            <label class="field-label-inline"><span class="req">*</span>{{ field.label }}</label>
            <div class="stars">
              <span v-for="n in 5" :key="n"
                    class="star"
                    :class="{ active: Number(ticket[field.scoreKey]) >= n }"
                    @click="ticket[field.scoreKey] = String(n)">{{ Number(ticket[field.scoreKey]) >= n ? '★' : '☆' }}</span>
            </div>
            <span class="star-score">{{ ticket[field.scoreKey] ? ticket[field.scoreKey] + ' 星' : '未评分' }}</span>
            <textarea v-if="needExplain(field.scoreKey)"
                      v-model="ticket[field.reasonKey]"
                      class="field-textarea eval-text"
                      :placeholder="`评分${ticket[field.scoreKey]}星，请说明原因（不少于10字）`" />
          </div>
        </div>
      </div>

      <!-- 陪诊小结 -->
      <div class="card">
        <div class="card-header" @click="toggleSection('summary')">
          <span class="card-title"><span class="bar"></span>陪诊小结 <span class="required-count" v-if="summaryRequiredMissing">有未填必填项</span></span>
          <i class="fa" :class="sections.summary ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.summary">
          <div class="field-row" style="flex-direction: column;">
            <label class="field-label-inline" style="width:auto;padding-top:0;margin-bottom:6px;"><span class="req">*</span>陪诊小结</label>
            <textarea v-model="ticket.remarks" class="field-textarea" placeholder="请输入备注（陪诊小结）"></textarea>
          </div>
        </div>
      </div>

      <!-- 上传图片 -->
      <div class="card">
        <div class="card-header" @click="toggleSection('upload')">
          <span class="card-title"><span class="bar"></span>上传图片 <span class="upload-tip">* 为必传项</span></span>
          <i class="fa" :class="sections.upload ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </div>
        <div class="card-body" v-show="sections.upload">
          <div class="upload-item" v-for="up in uploadFields" :key="up.key">
            <div class="upload-label-row">
              <span class="req" v-if="up.required">*</span>
              <span>{{ up.label }}</span>
            </div>
            <van-uploader
                v-model="uploadModels[up.key]"
                :max-count="up.max"
                :multiple="up.max > 1"
                :before-read="uploadBeforeRead"
                :after-read="uploadAfterRead"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="fixed bottom-0 left-0 right-0 p-3 bottom-bar z-10">
      <div class="flex gap-2">
        <button @click="showRecords" class="btn btn-records">查看记录</button>
        <button @click="onSave" class="btn btn-save">暂存</button>
        <button @click="onFinish" class="btn btn-finish" :disabled="submitting">完成服务单</button>
      </div>
    </div>

    <!-- 时间选择器 -->
    <div v-if="timePickerShow" class="w-full fixed bottom-0 left-0">
      <div class="fixed inset-0 z-10 bg-#00000020" @click="onTimeCancel" />
      <van-datetime-picker
          v-model="tempTime"
          type="datetime"
          class="z-11 relative"
          :title="getFieldLabel(activeTimeField)"
          :min-date="minDate"
          @confirm="onTimeConfirm"
          @cancel="onTimeCancel"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed, reactive, nextTick } from 'vue'
import Compressor from 'compressorjs'
import axios from 'axios'
import { api } from '@/api'
import {useLoadingStore, useToastStore, useUserStore} from '@/stores'
import { $formatErrorMessage, $formatDate } from '@/helpers'
import { useRouter } from 'vue-router/composables'
import { $getToken, $getCurrentDate } from '@/helpers'
import { isMobile } from '@/utils'

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()
const userStore = useUserStore()
const router = useRouter()

// 分组折叠状态（默认只展开基本信息）
const sections = reactive({
  basic: true,
  time: false,
  check: false,
  eval: false,
  summary: false,
  upload: false,
})
function toggleSection(key: keyof typeof sections) {
  sections[key] = !sections[key]
}

// 评价卡片引用，用于提交校验失败时自动滚动定位
const evalCardRef = ref<HTMLElement | null>(null)

// ticket 数据
const ticket = ref({
  escort_name: '',
  channel: 'default',
  customer_name: '',
  visit_hospital: '',
  visit_deparment: '',
  visit_doctor: '',
  level: '',
  register_fee: '',
  patient_disease: '',
  expert_diagnosis: '',
  medical_name: '',
  take_medical_time: '',
  expert_suggest: '',
  appointment_time: '',
  escort_reach_hospital_time: '',
  cusotomer_reach_hospital_time: '',
  take_number_time: '',
  in_clinic_time: '',
  out_clinic_time: '',
  check_project: '',
  check_time_slot: '',
  check_appointment_time: '',
  service_end_time: '',
  remarks: '',
  is_hospital_cert: '',
  is_hospital: '',
  doctor_attitude_score: '',
  doctor_ability_score: '',
  hospital_env_score: '',
  doctor_attitude_reson: '',
  doctor_ability_reson: '',
  hospital_env_reson: ''
})

// 上传字段配置
const uploadFields = [
  { key: 'reach_proof_images', label: '到院打卡照片', max: 1, required: true },
  { key: 'leave_proof_images', label: '离院打卡照片', max: 1, required: true },
  { key: 'register_images', label: '挂号条（无挂号条请传预约截图或报道截图）', max: 1, required: true },
  { key: 'check_images', label: '调查表-满意度调查表', max: 1, required: true },
  { key: 'other_images', label: '其他（住院单，检查单，处方单）', max: 5, required: false },
] as const
const uploadModels = reactive<Record<string, any[]>>({
  reach_proof_images: [],
  leave_proof_images: [],
  register_images: [],
  check_images: [],
  other_images: [],
})

const submitting = ref(false)

// ========== 医院搜索（本地过滤，不请求接口） ==========
const hospitalList = ref<{ id: number; province: string; city: string; hospital_text: string }[]>([])
const hospitalKeyword = ref('')
const hospitalDropdownShow = ref(false)
// 当前选中的医院完整信息（用于提交时拼接省市）
const selectedHospital = ref<{ province: string; city: string; hospital_text: string } | null>(null)

// 实时过滤（匹配医院名/省/市）
const filteredHospitals = computed(() => {
  const kw = hospitalKeyword.value.trim().toLowerCase()
  if (!kw) return hospitalList.value.slice(0, 30) // 未输入时展示前 30 条
  return hospitalList.value
    .filter(h =>
      h.hospital_text.toLowerCase().includes(kw) ||
      h.province.toLowerCase().includes(kw) ||
      h.city.toLowerCase().includes(kw)
    )
    .slice(0, 30)
})

// 选中医院
function selectHospital(item: { province: string; city: string; hospital_text: string }) {
  selectedHospital.value = item
  hospitalKeyword.value = item.hospital_text
  ticket.value.visit_hospital = item.hospital_text
  hospitalDropdownShow.value = false
}

// 清空医院
function clearHospital() {
  hospitalKeyword.value = ''
  ticket.value.visit_hospital = ''
  selectedHospital.value = null
}

// 输入时同步：手动输入则清空选中状态，visit_hospital 跟随输入
function onHospitalInput() {
  hospitalDropdownShow.value = true
  if (selectedHospital.value && hospitalKeyword.value !== selectedHospital.value.hospital_text) {
    selectedHospital.value = null
  }
  ticket.value.visit_hospital = hospitalKeyword.value
}

// 输入框失焦时关闭下拉（延迟以允许点击选项）
function onHospitalBlur() {
  setTimeout(() => { hospitalDropdownShow.value = false }, 200)
}

// 基本信息必填项缺失提示
const basicRequiredMissing = computed(() => {
  return ['customer_name', 'visit_hospital', 'visit_deparment', 'visit_doctor', 'register_fee', 'expert_diagnosis']
    .some(f => !ticket.value[f]?.trim())
})

// 陪诊小结必填项缺失提示
const summaryRequiredMissing = computed(() => {
  return !ticket.value.remarks?.trim()
})

// 评价必填项缺失提示（三项星级评分任一未选）
const evalRequiredMissing = computed(() => {
  return ['doctor_attitude_score', 'doctor_ability_score', 'hospital_env_score']
    .some(f => !ticket.value[f]?.trim())
})

// ========== 时间字段 ==========
const timeFieldList = [
  'appointment_time', 'escort_reach_hospital_time', 'cusotomer_reach_hospital_time',
  'take_number_time', 'in_clinic_time', 'out_clinic_time',
  'check_appointment_time', 'service_end_time',
]
const TIME_FIELDS = [
  'take_medical_time', 'appointment_time', 'escort_reach_hospital_time',
  'cusotomer_reach_hospital_time', 'take_number_time', 'in_clinic_time',
  'out_clinic_time', 'service_end_time', 'check_appointment_time',
]
// 时间字段是否必填（用于 label 红星）
const TIME_REQUIRED = ['escort_reach_hospital_time', 'take_number_time']

function formatLabelWithReq(field: string): string {
  const label = getFieldLabel(field)
  return TIME_REQUIRED.includes(field) ? `<span class="req">*</span>${label}` : label
}

const timePickerShow = ref(false)
const activeTimeField = ref('')
const tempTime = ref<Date>(new Date())
const minDate = new Date(2020, 0, 1)

function openTimePicker(field: string) {
  activeTimeField.value = field
  const current = (ticket.value as any)[field] as string
  if (current) {
    tempTime.value = new Date(current.replace(/-/g, '/'))
    if (isNaN(tempTime.value.getTime())) tempTime.value = new Date()
  } else {
    tempTime.value = new Date()
  }
  timePickerShow.value = true
}
function onTimeConfirm(val: Date) {
  if (activeTimeField.value) {
    (ticket.value as any)[activeTimeField.value] = $formatDate(val)
  }
  timePickerShow.value = false
}
function onTimeCancel() {
  timePickerShow.value = false
}

async function showRecords() {
  router.push({ name: 'RecordSearch' })
}

// 暂存
async function onSave() {
  try {
    $showLoading()
    // 暂存前修正上传中的状态，避免刷新后卡在"上传中"
    Object.keys(uploadModels).forEach(key => {
      uploadModels[key].forEach((f: any) => {
        if (f.status === 'uploading') {
          f.status = f.url ? 'done' : 'failed'
          f.message = f.url ? '' : '上传失败，请重试'
        }
      })
    })
    localStorage.setItem('ticketData', JSON.stringify(ticket.value))
    Object.keys(uploadModels).forEach(key => {
      localStorage.setItem(key, JSON.stringify(uploadModels[key]))
    })
    if (selectedHospital.value) {
      localStorage.setItem('selectedHospital', JSON.stringify(selectedHospital.value))
    }
    $toast('数据已暂存')
    $hideLoading()
  } catch (error) {
    $toast($formatErrorMessage(error))
    $hideLoading()
  }
}

// 提交
async function onFinish() {
  if (submitting.value) return
  // 兜底校验：提交前再检查一次姓名是否为手机号
  if (isMobile(userStore.$state.name)) {
    $toast('请先补充真实姓名')
    router.push({ name: 'collect-name', query: { r: 'add-order' } })
    return
  }
  if (!validateRequiredFields()) {
    $toast('请完成所有必填项')
    // 展开必填项所在分组方便用户查看
    sections.basic = true
    sections.time = true
    sections.summary = true
    // 评分未填时展开评价分组并自动滚动定位
    if (evalRequiredMissing.value) {
      sections.eval = true
      nextTick(() => {
        evalCardRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
    return
  }
  const minLenError = validateMinLength()
  if (minLenError) {
    $toast(minLenError)
    sections.summary = true
    return
  }
  submitting.value = true
  try {
    $showLoading()
    // 拼接 visit_hospital：有选中医院则带省市，否则用纯文本
    const visitHospital = selectedHospital.value
      ? [selectedHospital.value.province, selectedHospital.value.city, ticket.value.visit_hospital].filter(Boolean).join('/')
      : ticket.value.visit_hospital

    const { code } = await api.post('/escorth5/serv_order/add_order', {
      escort_name: ticket.value.escort_name,
      channel: ticket.value.channel,
      customer_name: ticket.value.customer_name,
      visit_hospital: visitHospital,
      visit_deparment: ticket.value.visit_deparment,
      visit_doctor: ticket.value.visit_doctor,
      level: ticket.value.level,
      register_fee: ticket.value.register_fee,
      patient_disease: ticket.value.patient_disease,
      expert_diagnosis: ticket.value.expert_diagnosis,
      medical_name: ticket.value.medical_name,
      take_medical_time: ticket.value.take_medical_time,
      expert_suggest: ticket.value.expert_suggest,
      appointment_time: ticket.value.appointment_time,
      escort_reach_hospital_time: ticket.value.escort_reach_hospital_time,
      cusotomer_reach_hospital_time: ticket.value.cusotomer_reach_hospital_time,
      take_number_time: ticket.value.take_number_time,
      in_clinic_time: ticket.value.in_clinic_time,
      out_clinic_time: ticket.value.out_clinic_time,
      check_project: ticket.value.check_project,
      check_time_slot: ticket.value.check_time_slot,
      check_appointment_time: ticket.value.check_appointment_time,
      service_end_time: ticket.value.service_end_time,
      remarks: ticket.value.remarks,
      is_hospital_cert: ticket.value.is_hospital_cert,
      is_hospital: ticket.value.is_hospital,
      reach_proof_images: uploadModels.reach_proof_images.filter(i => i.status === 'done').map(i => i.url),
      leave_proof_images: uploadModels.leave_proof_images.filter(i => i.status === 'done').map(i => i.url),
      register_images: uploadModels.register_images.filter(i => i.status === 'done').map(i => i.url),
      check_images: uploadModels.check_images.filter(i => i.status === 'done').map(i => i.url),
      other_images: uploadModels.other_images.filter(i => i.status === 'done').map(i => i.url),
      doctor_attitude_score: ticket.value.doctor_attitude_score,
      doctor_ability_score: ticket.value.doctor_ability_score,
      hospital_env_score: ticket.value.hospital_env_score,
      doctor_attitude_reson: ticket.value.doctor_attitude_reson,
      doctor_ability_reson: ticket.value.doctor_ability_reson,
      hospital_env_reson: ticket.value.hospital_env_reson,
    })
    if (code === 200) {
      localStorage.removeItem('ticketData')
      localStorage.removeItem('selectedHospital')
      Object.keys(uploadModels).forEach(key => localStorage.removeItem(key))
      $toast('服务单已完成')
      setTimeout(() => location.reload(), 3000)
    } else {
      submitting.value = false
    }
  } catch (error) {
    $toast($formatErrorMessage(error))
    submitting.value = false
  } finally {
    $hideLoading()
  }
}

// 页面加载
onMounted(async () => {
  // 强制刷新用户信息，避免 store 缓存导致手机号姓名漏检
  await userStore.init({ force: true })
  if (isMobile(userStore.$state.name)) {
    router.replace({ name: 'collect-name', query: { r: 'add-order' } })
    return
  }
  // 拉取三甲医院列表
  try {
    const { data } = await api.get('/escorth5/serv_order/hospital_list')
    hospitalList.value = data?.list || []
  } catch (e) {
    hospitalList.value = []
  }
  // 恢复暂存
  const storedTicketData = localStorage.getItem('ticketData')
  if (storedTicketData) {
    ticket.value = JSON.parse(storedTicketData)
    // 兼容老数据：如果暂存数据中没有 channel 字段，设置默认值
    if (!ticket.value.channel) {
      ticket.value.channel = 'default'
    }
  }
  // 恢复医院选中状态
  const storedHospital = localStorage.getItem('selectedHospital')
  if (storedHospital) {
    try {
      selectedHospital.value = JSON.parse(storedHospital)
      hospitalKeyword.value = selectedHospital.value?.hospital_text || ticket.value.visit_hospital
    } catch {}
  } else if (ticket.value.visit_hospital) {
    hospitalKeyword.value = ticket.value.visit_hospital
    const matched = hospitalList.value.find(h => h.hospital_text === ticket.value.visit_hospital)
    if (matched) selectedHospital.value = { province: matched.province, city: matched.city, hospital_text: matched.hospital_text }
  }
  // 恢复图片
  Object.keys(uploadModels).forEach(key => {
    const stored = localStorage.getItem(key)
    if (stored) {
      const arr = JSON.parse(stored)
      // 修正上传中断的状态：有url标记成功，无url标记失败
      arr.forEach((f: any) => {
        if (f.status === 'uploading') {
          if (f.url) {
            f.status = 'done'
            f.message = ''
          } else {
            f.status = 'failed'
            f.message = '上传失败，请重试'
          }
        }
      })
      uploadModels[key] = arr
    }
  })
  // 陪诊姓名默认填充当前登录用户姓名（手机号不填充）
  const userName = userStore.$state.name
  if (userName && !isMobile(userName) && !ticket.value.escort_name?.trim()) {
    ticket.value.escort_name = userName
  }
})

// 必填验证（与页面带 * 号字段保持一致，陪诊小结也必填）
function validateRequiredFields() {
  const requiredFields = [
    'escort_name','customer_name','visit_hospital', 'visit_deparment','visit_doctor', 'register_fee','expert_diagnosis',
    'escort_reach_hospital_time', 'take_number_time', 'remarks',
    'doctor_attitude_score', 'doctor_ability_score', 'hospital_env_score'
  ]
  return requiredFields.every(field => ticket.value[field]?.trim())
}

// 不少于10字的评价字段校验
// 评价字段配置（星级 ≤3 需要文字说明 ≥10 字）
const evalFields = [
  { scoreKey: 'doctor_attitude_score', reasonKey: 'doctor_attitude_reson', label: '医生态度' },
  { scoreKey: 'doctor_ability_score', reasonKey: 'doctor_ability_reson', label: '医生能力' },
  { scoreKey: 'hospital_env_score', reasonKey: 'hospital_env_reson', label: '医院环境' },
]
function needExplain(scoreField: string): boolean {
  const n = Number(ticket.value[scoreField])
  return n > 0 && n <= 3
}
function validateMinLength(): string | null {
  // 陪诊小结不少于10字
  if ((ticket.value.remarks?.trim() ?? '').length < 10) {
    return '陪诊小结不能少于10个字'
  }
  // 评价 ≤3 星需要文字说明 ≥10 字
  for (const { scoreKey, reasonKey, label } of evalFields) {
    const n = Number(ticket.value[scoreKey])
    if (n > 0 && n <= 3) {
      const text = (ticket.value[reasonKey] ?? '').trim()
      if (text.length < 10) {
        return `${label}评分为${n}星，需说明原因且不少于10个字`
      }
    }
  }
  return null
}

function getFieldLabel(field: string) {
  switch (field) {
    case 'customer_name': return '客户姓名'
    case 'visit_hospital': return '就诊医院'
    case 'visit_deparment': return '就诊科室'
    case 'visit_doctor': return '专家名称'
    case 'level': return '级别'
    case 'register_fee': return '挂号费'
    case 'patient_disease': return '患者基本病情'
    case 'expert_diagnosis': return '专家诊断'
    case 'medical_name': return '药品名称'
    case 'take_medical_time': return '取药时间段'
    case 'expert_suggest': return '专家建议'
    case 'appointment_time': return '约定见面时间'
    case 'escort_reach_hospital_time': return '陪诊到院时间'
    case 'cusotomer_reach_hospital_time': return '客户到院时间'
    case 'take_number_time': return '取号时间'
    case 'in_clinic_time': return '进入诊室时间'
    case 'out_clinic_time': return '出诊室时间'
    case 'check_project': return '检查项目'
    case 'check_time_slot': return '办理检查时间段'
    case 'service_end_time': return '服务结束时间'
    case 'check_appointment_time': return '检查预约时间'
    case 'remarks': return '备注（陪诊小结）'
    case 'is_hospital_cert': return '是否开住院证'
    case 'is_hospital': return '是否需要协调住院'
    case 'doctor_attitude_score': return '医生态度'
    case 'doctor_ability_score': return '医生能力'
    case 'hospital_env_score': return '医院环境'
    case 'reach_proof_images': return '到院打卡照片'
    case 'leave_proof_images': return '离院打卡照片'
    case 'register_images': return '挂号条'
    case 'check_images': return '调查表-满意度调查表'
    case 'other_images': return '其他'
    default: return field
  }
}

// 上传
function uploadBeforeRead(file: File) {
  if (Array.isArray(file)) {
    return Promise.all(file.map(item => new Promise(resolve => new Compressor(item, { success: resolve, error: (e: any) => console.error(e.message) }))))
  }
  return new Promise(resolve => new Compressor(file, { success: resolve, error: (e: any) => console.error(e.message) }))
}
function getExtension(filename: string) {
  return filename.split('.').pop() || ''
}
async function uploadAfterRead(file: { file: File; [key: string]: any }) {
  const files = Array.isArray(file) ? file : [file]
  for (const f of files) {
    f.status = 'uploading'
    f.message = '上传中...'
    try {
      const { data: signature } = await api.get(`/escorth5/serv_order/get_upload_params?ext=${getExtension(f.file.name)}`)
      const { status } = await axios.post(signature.host, {
        key: signature.key, policy: signature.policy, OSSAccessKeyId: signature.accessKeyId,
        signature: signature.signature, file: f.file,
      }, { headers: { 'Content-Type': 'multipart/form-data' } })
      if (status !== 204) { f.status = 'failed'; f.message = '上传失败'; return }
      f.status = 'done'
      f.url = signature.url
    } catch (error: any) {
      console.error(error)
      f.status = 'failed'
      f.message = '上传失败'
    }
  }
}
</script>

<style scoped>
/* ===== 顶部提示 ===== */
.notice-tip {
  background: linear-gradient(90deg, #fffbeb 0%, #fef3c7 100%);
  border: 1px solid #fcd34d;
  border-radius: 10px;
  padding: 10px 14px;
  color: #92400e;
  font-size: 13px;
  margin: 12px 12px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.notice-tip::before {
  content: "!";
  display: inline-flex;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #f59e0b;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

/* ===== 卡片分组 ===== */
.card {
  background: #fff;
  border-radius: 12px;
  margin: 10px 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  user-select: none;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}
.card-title .bar {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #3b82f6;
  border-radius: 2px;
  margin-right: 8px;
}
.card-header i {
  color: #94a3b8;
  font-size: 18px;
  transition: transform .2s;
}
.required-count {
  font-size: 11px;
  color: #ef4444;
  background: #fef2f2;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  font-weight: 500;
}
.upload-tip {
  font-size: 11px;
  color: #94a3b8;
  margin-left: 6px;
  font-weight: 400;
}
.card-body {
  padding: 4px 16px 14px;
}

/* ===== 字段行（内联布局） ===== */
.field-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  gap: 10px;
}
.field-row:last-child {
  border-bottom: none;
}
.field-label-inline {
  flex-shrink: 0;
  width: 90px;
  font-size: 14px;
  color: #475569;
  padding-top: 12px;
  line-height: 1.4;
}
.field-label-inline .req {
  color: #ef4444;
  margin-right: 2px;
}
/* v-html 注入的内容不会带 scoped 属性，需要用 :deep() 穿透 */
.field-label-inline :deep(.req) {
  color: #ef4444;
  margin-right: 2px;
}
.field-input-inline {
  flex: 1;
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  background: #fff;
  box-sizing: border-box;
  min-height: 42px;
  transition: border-color .2s;
}
select.field-input-inline {
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
  padding-right: 36px;
  cursor: pointer;
}
select.field-input-inline:focus {
  outline: none;
  border-color: #3b82f6;
}
.field-input-inline:focus {
  outline: none;
  border-color: #3b82f6;
}
.field-input-inline:read-only {
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
}
.field-input-inline::placeholder {
  color: #cbd5e1;
  font-size: 14px;
}
.field-textarea {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  background: #fff;
  box-sizing: border-box;
  min-height: 100px;
  resize: vertical;
  line-height: 1.6;
}
.field-textarea:focus {
  outline: none;
  border-color: #3b82f6;
}

/* ===== 医院搜索 ===== */
.hospital-search-row {
  flex-direction: column;
}
.hospital-search-row .field-label-inline {
  width: auto;
  padding-top: 0;
  margin-bottom: 6px;
}
.hospital-search-box {
  width: 100%;
  position: relative;
}
.hospital-search-box .field-input-inline {
  width: 100%;
  padding-right: 32px;
}
.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #cbd5e1;
  font-size: 16px;
  cursor: pointer;
}
.hospital-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,.1);
  max-height: 260px;
  overflow-y: auto;
  z-index: 50;
}
.hospital-option {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  cursor: pointer;
}
.hospital-option:active {
  background: #eff6ff;
}
.hospital-name {
  font-size: 14px;
  color: #1e293b;
  line-height: 1.4;
}
.hospital-area {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}
.hospital-empty {
  padding: 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

/* ===== 上传 ===== */
.upload-item {
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.upload-item:last-child {
  border-bottom: none;
}
.upload-label-row {
  font-size: 14px;
  color: #475569;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.upload-label-row .req {
  color: #ef4444;
}

/* ===== 底部按钮 ===== */
.bottom-bar {
  background: #fff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -2px 12px rgba(0,0,0,.06);
}
.btn {
  flex: 1;
  padding: 12px 0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  transition: all .2s;
}
.btn:active { transform: scale(.97); }
.btn:disabled { opacity: .6; }
.btn-records { background: #64748b; }
.btn-records:active { background: #475569; }
.btn-save { background: #3b82f6; }
.btn-save:active { background: #2563eb; }
.btn-finish { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
.btn-finish:active { background: #047857; }

/* ===== 评价星级 ===== */
.eval-row {
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.eval-row .field-label-inline {
  width: auto;
  padding-top: 0;
  margin-bottom: 4px;
}
.stars {
  display: flex;
  gap: 6px;
  font-size: 28px;
  line-height: 1;
}
.star {
  color: #cbd5e1;
  cursor: pointer;
  user-select: none;
  transition: color 0.15s;
}
.star:hover { color: #94a3b8; }
.star.active { color: #f59e0b; }
.star-score {
  color: #64748b;
  font-size: 13px;
  margin-left: 2px;
}
.eval-text {
  margin-top: 4px;
  min-height: 70px;
}
</style>